export default __webpack_public_path__ + "static/6663-81b159fb1580d3c105c6dd789320b204.jpg";